
/**
 * lang.js
 */

const BASEURI = '/common';

// 配置网站支持的语言
const langs = {
  en: 'en',
  'zh-cn': 'zh-CN'
}

// en cn 106 63
const languages = {
  en: 'en',
  'zh-CN': 'cn'
}
const tids = {
  en: '106',
  'zh-CN': '63'
}

const getLanguage = lang => {
  return languages[lang] || 'en'
}

/**
 * 获取浏览器的语言设置
 * 如果没找到则返回一个默认值 en
 */
export const getLang = () => {
  let lowerLang = (window.navigator.language ||
      window.navigator.browserLanguage ||
      'en').toLowerCase()

  // default: en
  return langs[lowerLang] || 'en'
}

/**
 * 设置 html 标签的 lang
 */
export const setHtmlLang = lang => {
  // documentElement 根root HTML
  document.documentElement.setAttribute('lang', lang)
}


export const getProductstypeUrl = lang => {
  const language = getLanguage(lang)
  const tid = tids[lang] || '106'
  return `${BASEURI}/productstype.php?language=${language}&tid=${tid}&num=100`
}


//获取首页的内容
export const getHomeInfo = () => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getIndex.php`
}


//获取About的内容
export const getAbout = () => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getAbout.php`
}

//获取企业荣誉的内容
export const getHonor = () => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getHonor.php`
}

//获取联系我们的内容
export const getContact = () => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getContact.php`
}


//获取实验室的内容
export const getLaboratory = () => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getLaboratory.php`
}


//获取底部的内容
export const getFooter = () => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getFooter.php`
}


//获取Products类别的内容
export const getProductType = () => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getProductType.php`
}



//获取产品列表
export const getProducts = (cid) => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getProduct.php?cid=${cid}`
}


//获取更多Products的内容
export const moreProducts = (cid, num) => {
  // const language = getLanguage(lang)
  return `${BASEURI}/moreProducts.php?cid=${cid}&num=${num}`
}


//获取产品详情
export const getProInfo = (id) => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getProductPage.php?id=${id}`
}





//获取新闻列表
export const getNews = (cid) => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getNews.php?cid=${cid}`
}




//获取新闻详情
export const getNewsPage = (id) => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getPage.php?id=${id}`
}



//获取投资者关系的内容
export const getGover = () => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getGover.php`
}


//获取公告发布的内容
export const getAnnounce = () => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getAnnounce.php`
}


//获取投资者活动的内容
export const getActivity = () => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getActivity.php`
}

//获取投资者在线的内容
export const getOnLine = () => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getOnLine.php`
}


//获取产品分类
export const getProType = () => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getProType.php`
}

//获取产品
export const getProduct = (name,page,id) => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getProduct.php?type_1=${name}&page=${page}&id=${id}`
}


//搜索产品
export const getProduct2 = (name,page) => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getProduct.php?search=${name}&page=${page}`
}


// 获取股票
export const getNumber = () => {
  // const language = getLanguage(lang)
  return `${BASEURI}/gpApi.php`
}

//获取产品详情
export const getProductPage = (id) => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getProductPage.php?id=${id}`
}


//获取产品2
export const getProduct_2 = (name,page,id) => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getProduct_2.php?type_2=${name}&page=${page}&id=${id}`
}


//搜索产品2
export const getProduct_22 = (name,page) => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getProduct_2.php?search=${name}&page=${page}`
}


//获取别的
export const getOther = (cid) => {
  // const language = getLanguage(lang)
  return `${BASEURI}/getOtherPro.php?cid=${cid}`
}
